module.exports = __webpack_public_path__ + "img/icon-70.17fd94f3.png";